import React, { useEffect, useState } from "react";
import api, { API_BASE } from "@/lib/api";
import { Modal } from "@/components/ui-kit";
import { Download as DLIcon } from "lucide-react";

/**
 * Inline preview modal for an uploaded file.
 * Accepts a `file` object: { id, path, filename, content_type } OR just an id.
 * Renders <img> for images, <embed> for PDF.
 */
export default function FilePreview({ open, onClose, fileId, contentType, filename, topmost = false, level = 0 }) {
  const [blobUrl, setBlobUrl] = useState(null);
  const [ct, setCt] = useState(contentType);

  useEffect(() => {
    let mounted = true;
    let createdUrl = null;
    if (open && fileId) {
      api.get(`/files/${fileId}`, { responseType: "blob" })
        .then((r) => {
          if (!mounted) return;
          setCt(r.headers["content-type"] || contentType);
          createdUrl = URL.createObjectURL(r.data);
          setBlobUrl(createdUrl);
        })
        .catch(() => setBlobUrl(null));
    } else if (!open) {
      setBlobUrl(null);
    }
    return () => { mounted = false; if (createdUrl) URL.revokeObjectURL(createdUrl); };
  }, [open, fileId, contentType]);

  return (
    <Modal open={open} onClose={onClose} title={filename || "Preview"} size="xl" topmost={topmost} level={level}>
      {!blobUrl && <div className="py-10 text-center text-sm text-stone-500">Memuat…</div>}
      {blobUrl && (ct || "").startsWith("image/") && (
        <img src={blobUrl} alt="" className="max-h-[70vh] mx-auto" />
      )}
      {blobUrl && ct === "application/pdf" && (
        <iframe src={blobUrl} title="pdf" className="w-full h-[70vh] border border-stone-200" />
      )}
      {blobUrl && (
        <div className="mt-4 pt-4 border-t border-stone-200 flex justify-end">
          <a href={blobUrl} download={filename || "file"} className="inline-flex items-center gap-2 px-3 py-1.5 border border-stone-300 text-sm hover:bg-stone-50">
            <DLIcon className="h-3.5 w-3.5" />Unduh
          </a>
        </div>
      )}
    </Modal>
  );
}
